import {GetRecommendationsPageResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/product_recommendations_page/v1/service.types';
import {useTranslation} from '@aboutyou/i18n';
import {
  GoBackWithProductImage,
  mediaDesktopAndUp,
  mediaLargeScreens,
  mobileOnly,
} from '@aboutyou/ui-components';
import React from 'react';
import {GoBackView} from '../../../features/GoBackView/GoBackView';
import {
  ProductTile,
  ProductTileProps,
} from '../../../features/ProductTile/ProductTile';

import styled, {css} from 'styled-components';
import {SimilarProductsEmpty} from './SimilarProductsEmpty';

export interface SimilarProductsStreamViewProps {
  onClickAddToBasket?: (productId: number) => void;
  showProductNameInNav?: boolean;
  compact?: boolean;
  ProductTileComponent?: React.FC<
    Omit<ProductTileProps, 'ProductTileComponent'>
  >;
}

const Center = styled.li`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  margin-top: 50px;
  ${mobileOnly(
    css`
      margin-top: 25px;
    `,
  )}
  grid-column: span 2;

  @media ${mediaDesktopAndUp} {
    grid-column: span 3;
  }

  @media ${mediaLargeScreens} {
    grid-column: span 4;
  }
`;

export const SimilarProductsStreamView = (
  props: SimilarProductsStreamViewProps & GetRecommendationsPageResponse,
) => {
  const {
    product,
    recommendations,
    headline,
    showProductNameInNav,
    onClickAddToBasket,
    ProductTileComponent = ProductTile,
  } = props;

  const {t} = useTranslation();

  const firstImage = product.gallery?.elements?.[0];
  const productImageSrc =
    firstImage?.type?.$case === 'image' ? firstImage.type.image.image.src : '';
  const productImageAlt =
    firstImage?.type?.$case === 'image'
      ? firstImage.type.image.image.description
      : '';
  const productImageEnclosed =
    firstImage?.type?.$case === 'image'
      ? firstImage.type.image.image.isEnclosed ?? false
      : false;

  return (
    <>
      <Wrapper>
        <GoBackView
          View={({onClick}) => (
            <GoBackWithProductImage
              onClick={onClick}
              headline={headline}
              productSrc={productImageSrc}
              productName={product.productName ?? ''}
              productAlt={productImageAlt}
              isProductImageEnclosed={productImageEnclosed}
              showProductName={showProductNameInNav}
              testId="SimilarProductsGoBackNavigation"
            />
          )}
          backLinkTarget={{url: product.link.url, external: false}}
        />
      </Wrapper>
      {recommendations.length ? (
        recommendations.map((recommendation, i) => (
          <ProductTileComponent
            key={recommendation.productId}
            tile={recommendation}
            streamPosition={i}
            {...(onClickAddToBasket && {
              addCtaLabel: t('Add to basket'),
              onClickAddCta: tile => onClickAddToBasket(tile.product.id),
              onColorClick: colorProductId => {
                onClickAddToBasket(colorProductId);
              },
            })}
          />
        ))
      ) : (
        <Center>
          <SimilarProductsEmpty />
        </Center>
      )}
    </>
  );
};

const Wrapper = styled.div`
  grid-column: span 2;

  @media ${mediaDesktopAndUp} {
    grid-column: span 3;
  }

  @media ${mediaLargeScreens} {
    grid-column: span 4;
  }
`;
